var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-billing-settings',{attrs:{"client":_vm.$clientData.client,"is-sticky":true,"tag":"u-contextualise"},on:{"refreshClient":function($event){return _vm.$clientMethods.reloadData()}}})}
var staticRenderFns = []

export { render, staticRenderFns }